import axios from '@/common/utils/request'

// 登录方法
export function login(params) {
  return axios({
    method: 'post',
    url: '/enroll/student/login',
    data: params
  })
}

// 获取验证码
export function getCode() {
  return axios({
    url: '/code',
    method: 'get'
  })
}

// 检查验证码
export function checkCode(params) {
  return axios({
    url: '/checkCode',
    method: 'post',
    data: params
  })
}

